import { PageHero } from "@/components/Sections";
import { LeadForm } from "@/components/LeadForm";
import { Reveal } from "@/components/Reveal";
import { Search, ClipboardCheck, ShieldCheck, ShoppingCart, Truck, FileCheck, Globe2 } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1681167816895-940c56e0d2a5?w=1600";

const steps = [
  { icon: Search, label: "Recherche" },
  { icon: ClipboardCheck, label: "Sélection" },
  { icon: ShieldCheck, label: "Vérification" },
  { icon: ShoppingCart, label: "Achat" },
  { icon: Truck, label: "Importation" },
  { icon: FileCheck, label: "Administratif" },
];

export default function Import() {
  return (
    <div data-testid="import-page">
      <PageHero
        overline="Importation de véhicules"
        title="Une voiture à l'étranger ? Nous nous occupons de votre projet."
        subtitle="Vous avez repéré un véhicule à l'étranger ou souhaitez un modèle rare sur le marché français ? Nous vous accompagnons à chaque étape."
        image={HERO}
      />

      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {steps.map((s, i) => (
              <div key={s.label} className="relative bg-[#121212] border border-white/10 rounded-sm p-6 text-center">
                <span className="absolute top-3 right-3 font-display text-xs text-[#C5A059]">{String(i + 1).padStart(2, "0")}</span>
                <s.icon className="h-7 w-7 text-[#C5A059] mx-auto" />
                <p className="text-sm font-medium text-white mt-4">{s.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </section>

      <section className="max-w-3xl mx-auto px-5 lg:px-8 pb-24">
        <Reveal>
          <div className="bg-[#0f0f0f] border border-white/10 rounded-sm p-8 lg:p-10">
            <div className="flex items-center gap-3 mb-6">
              <Globe2 className="h-6 w-6 text-[#C5A059]" />
              <h2 className="font-display text-2xl font-bold text-white">Parlez-nous de votre projet</h2>
            </div>
            <LeadForm
              type="importation"
              submitLabel="Envoyer mon projet d'importation"
              fields={[
                { name: "brand", label: "Marque recherchée", type: "text", placeholder: "Ex : Audi" },
                { name: "model", label: "Modèle recherché", type: "text", placeholder: "Ex : RS6" },
                { name: "country", label: "Pays / source", type: "text", placeholder: "Allemagne, Belgique..." },
                { name: "budget", label: "Budget", type: "text", placeholder: "Ex : 80 000 €" },
                { name: "link", label: "Lien de l'annonce (si trouvée)", type: "text", full: true, placeholder: "https://..." },
                { name: "message", label: "Détails de votre projet", type: "textarea", full: true },
              ]}
            />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
